export default {"link":"BSl18","name":"WOuYi","inner":"kiERX","avatar":"yd4mT"};